import { Button, Stack } from "@mui/material";
import { ReactComponent as Warning } from "../../../../Assets/Images/WarningICON.svg";
import { CommonMessage } from "../../../atoms/CommonMessage/CommonMessage";
import { HorizontalDivide } from "../../../atoms/HorizontalDivide/HorizontalDivide";
export const TaxConfiguarationNoContent = ({ t, setContentID }) => {
  return (
    <Stack direction={"column"}>
      <CommonMessage
        icon={<Warning width={"16px"} height={"16px"} />}
        text={t("glossary:tax-configuration:please-include-tax")}
        widthIconcell={'auto'}
        spacing={1}
      />
      <HorizontalDivide marginTop={"23px"} marginBottom={"20px"} />
      <Button
        onClick={() => {
          setContentID({
            sceneID: 1,
            isUpdate: false,
          });
        }}
        variant="primaryBlue"
        sx={{ borderRadius: "8px" }}
      >
        {t("glossary:tax-configuration:add-tax-button")}
      </Button>
    </Stack>
  );
};
